/* global URL */
// The client page's demo video (PAIRING_DEMO_VIDEO_URL). Plain JavaScript, so serve.mjs can read the same rules to
// allow the player's origin in its Content-Security-Policy with no build step.
//
// A YouTube, Vimeo or Loom link (watch, share or embed form) becomes that player's embed URL; YouTube plays from
// youtube-nocookie.com. A direct .mp4, .webm or .mov file plays in a <video> element. Any other https URL is embedded
// as given. Anything that is not https (or does not parse) is no video, and the section is left out.

const FILE = /\.(mp4|webm|mov|m4v)$/i;

/** @param {string | undefined} raw */
export function demoVideo(raw) {
  const value = (raw ?? '').trim();
  if (!value) return null;
  let url;
  try {
    url = new URL(value);
  } catch {
    return null;
  }
  if (url.protocol !== 'https:') return null;
  const host = url.hostname.replace(/^www\.|^m\./, '');
  const parts = url.pathname.split('/').filter(Boolean);

  let youtube = null;
  if (host === 'youtu.be') youtube = parts[0];
  else if (host === 'youtube.com' || host === 'youtube-nocookie.com') {
    if (parts[0] === 'watch') youtube = url.searchParams.get('v');
    else if (parts[0] === 'embed' || parts[0] === 'shorts' || parts[0] === 'live') youtube = parts[1];
  }
  if (youtube && /^[\w-]{6,}$/.test(youtube)) return iframe(`https://www.youtube-nocookie.com/embed/${youtube}?rel=0`);

  if (host === 'vimeo.com' && /^\d+$/.test(parts[0] ?? '')) {
    // An unlisted video's link carries its hash as the next path segment.
    const hash = parts[1] && /^[0-9a-f]+$/i.test(parts[1]) ? `?h=${parts[1]}` : '';
    return iframe(`https://player.vimeo.com/video/${parts[0]}${hash}`);
  }
  if (host === 'player.vimeo.com') return iframe(url.href);

  if (host === 'loom.com' && (parts[0] === 'share' || parts[0] === 'embed') && parts[1]) return iframe(`https://www.loom.com/embed/${parts[1]}`);

  if (FILE.test(url.pathname)) return { kind: 'file', src: url.href, origin: url.origin };
  return iframe(url.href);
}

/** @param {string} src */
function iframe(src) {
  return { kind: 'embed', src, origin: new URL(src).origin };
}
